import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'cabinet-header',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.primary,
    },
    toolbar: {
      height: 60,
      padding: theme.spacing(1.75, 4),
      minHeight: 60,
    },
  }),
  options
);

export default useStyles;
